// src/features/orders/components/WorkspaceHeader.tsx
import type { Order } from '../types/orders.types';
import { OrderStatusBadge } from './OrderStatusBadge';

interface WorkspaceHeaderProps {
  order: Order;
  onClose: () => void;
}

export function WorkspaceHeader({ order, onClose }: WorkspaceHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] px-4 py-3">
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          سفارش #{order.id}
        </p>
        <p className="mt-0.5 truncate text-xs text-[var(--vania-colors-text-secondary,#a3aab8)]">
          {order.serviceName}
        </p>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        <OrderStatusBadge status={order.status} />
        <button
          type="button"
          onClick={onClose}
          aria-label="بستن فضای کاری سفارش"
          className="rounded-full p-1 text-[var(--vania-colors-text-secondary,#a3aab8)] transition-colors hover:bg-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
